exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hover-5-wrapper[data-v-f1c12fd2]{width:242px;padding-bottom:10px}", ""]);

// exports
